import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TranslateModule } from '@ngx-translate/core';
import { ArcGisMapComponent } from '../arcgis-map/arcgis-map.component';
import { EntityPageModule } from '../entity-page/entity-page.module';
import { ImageGalleryModule } from '../image-gallery/image-gallery.module';
import { HbSectionComponent } from './hb-section.component';
import { HbSectionDetailsComponent } from './hb-section-details/hb-section-details.component';
import { AccordionPanelModule } from '../shared/components/accordion-panel/accordion-panel.module';

@NgModule({
    imports: [
        CommonModule,
        ButtonModule,
        TranslateModule,
        ArcGisMapComponent,
        EntityPageModule,
        ImageGalleryModule,
        AccordionPanelModule,
        FormsModule,
        InputSwitchModule,
    ],
    declarations: [HbSectionComponent, HbSectionDetailsComponent],
    exports: [HbSectionComponent],
})
export class HbSectionModule {}
